import React from 'react'
import { Button, Container, Row, Col } from 'react-bootstrap';
import styles from './resources.module.scss';

const Toolkits = () => {
    return (<>

        <Container className="outerContainer">
            <h1 className="centerText mb-4">Toolkits</h1>
            <Row>
                <Col md={8}>
                    <h2>AHRQ Hospital QI Toolkit</h2>
                    <p>The <a href="https://www.ahrq.gov/professionals/systems/hospital/qitoolkit/index.html">AHRQ Hospital QI Toolkit</a> is designed to help your hospital understand the AHRQ QIs, specifically the Patient Safety Indicators (PSIs) and Inpatient Quality Indicators (IQIs).</p>
                    <ul>
                        <li>The QI Toolkit serves as an “inventory” from which hospitals can select those tools that are most appropriate for their current quality improvement priorities and capabilities.
                        </li>
                        <li>Each of the tools is—by design—adaptable to the needs of an individual hospital.
                        </li>
                    </ul>
                </Col>
                <Col className='mb-5' md={4}>
                    <img src="/images/toolkit.png" />
                    <div className="pt-3">
                        <Button href="http://www.ahrq.gov/professionals/systems/hospital/qitoolkit/index.html">Download Hospital QI Toolkit</Button>
                    </div>
                </Col>

            </Row>
        </Container>
        <Container className="outerContainer">
            <h3>The tools are organized by the six quality improvement process steps, followed by a resources section:</h3>
            <ol className={styles.toolsteps}>
                <h4><li>Assessing Readiness to Change</li></h4>
                <p>Fact sheets on the QIs, a board presentation template, a survey to self-assess readiness to change, and case studies of QI Toolkit users.</p>
                <h4><li>Applying QIs to Your Hospital’s Data.</li></h4>
                <p>Software instructions to calculate the QI rates and tips for coding and documentation.</p>
                <h4><li>Identifying Priorities for Quality Improvement.</li></h4>
                <p>Prioritization worksheet, with example, and a presentation template aimed at engaging staff in the improvement process.</p>
                <h4><li>Implementing Evidence-Based Strategies to Improve Clinical Care.</li></h4>
                <p>25 indicator-specific best practices, a project charter, a gap analysis, and an implementation plan.</p>
                <h4><li>Monitoring Progress and Sustainability of Improvements.</li></h4>
                <p>Guide to support staff in tracking trends and monitoring progress for sustainable improvement.</p>
                <h4><li>Analyzing Return on Investment.</li></h4>
                <p>Step-by-step method for calculating the return on investment for an intervention implemented to improve performance on an AHRQ QI, and a case study of return on investment calculated by a hospital.</p>
                <h4 className="mt-4">Other Quality Improvement Resources.</h4>
                <p>Annotated list of related quality improvement guides and tools.</p>
            </ol>
        </Container>
        <Container className="outerContainer">
            <div className={styles.blueBox}>
                <h4>The toolkit has undergone a field test, evaluation, and revisions in response to feedback from six hospitals. In 2016, AHRQ updated the toolkit to include:</h4>
                <ul>
                    <li>Updated content to partially address the transition from ICD-9 to ICD-10, including updated documentation and coding practices</li>
                    <li>Guidance that can be used to improve pediatric quality in hospitals using the PDIs or other quality measures</li>
                    <li>A new presentation template for engaging staff in improvement efforts</li>
                    <li>Case studies of two hospitals that have successfully used the QI Toolkit</li>
                </ul>
            </div>
        </Container>
        <Container className="outerContainer">
            <Row>
                <Col md={4}>
                    <img src="/images/mapit.png" />
                    <div className="pt-3">
                        <Button href="https://www.qualityindicators.ahrq.gov/Downloads/Resources/MapIT_FY_2018.zip">Download MapIt Toolkit</Button>
                    </div>
                </Col>

                <Col md={8}>
                    <h2>MapIT Automated In-house Stand-alone Mapping Tool</h2>
                    <p>The AHRQ MapIT toolkit takes a selected set of ICD-9 codes, applies the CMS General Equivalence Mapping in various ways, then outputs the set of related ICD-9 and ICD-10 codes. The tool applies the GEM in a two-stage process using both the forward and backward maps in conjunction with a novel reverse mapping.</p>
                    <p>Download and install the MapIT tool to facilitate conversion of set names to ICD-10-CM/PCS codes.</p>
                    <ul>
                        <li><a href="https://www.qualityindicators.ahrq.gov/Downloads/Resources/AHRQ_MapIT_FY2018_Installation_Instructions.pdf">MapIT Users Guide FY2018</a> (PDF file, 1MB) (Posted: 3/26/2018)</li>
                        <li><a href="https://www.qualityindicators.ahrq.gov/Downloads/Resources/MapIT_FY_2018.zip">MapIT Tool (ZIP file, 53.2 MB)</a> (Posted: 3/26/2018)</li>
                        <li><a href="https://www.qualityindicators.ahrq.gov/Downloads/Resources/AHRQ_Quality_Indicators_MapIT_tool_documentation_March_2014.pdf">MapIT Tool documentation: Conversion of ICD9 to ICD10 </a> (PDF file, 99KB)</li>
                    </ul>
                                </Col>
            </Row>
        </Container>
        <Container className='outerContainer'>
            <p className="subtitle">NOTE: Persons with disabilities having difficulty accessing this information should contact us by email at <a href='mailto:QIsupport@ahrq.hhs.gov'>QIsupport@ahrq.hhs.gov</a>.</p>
            <p className="subtitle">The support email for users of the AHRQ QI Toolkits is <a href='mailto:QIsupport@ahrq.hhs.gov'>QIsupport@ahrq.hhs.gov</a>. AHRQ Quality Indicators support can also be reached by phone in the USA. The support voice mail is (301) 427-1949. Messages are responded to within three business days.</p>
        </Container>
    </>)
}

export default Toolkits;